import moment from "moment";
const date = {
  viewDate: function (date) {
    let currDateStr = moment().format("YYYY年MM月DD日 HH:mm:ss");
    let dateStr = moment(date).format("YYYY年MM月DD日 HH:mm:ss");
    if (dateStr) {
      if (dateStr.substr(0, 11) == currDateStr.substr(0, 11)) {
        return '今日' + dateStr.substr(12, 5);
      } else if (dateStr.substr(0, 5) == currDateStr.substr(0, 5)) {
        return dateStr.substr(5, 6);
      } else {
        return dateStr.substr(0, 11);
      }
    } else {
      return "";
    }
  },
  getDateStr: function (format) {
    return this.format(new Date(), format);
  },
  format: function (date, format) {
    if (!date) {
      return '';
    }
    let dateStr = moment(date).format(format);
    if (dateStr) {
      return dateStr;
    } else {
      return "";
    }
  },
  viewDateMinute: function (date) {
    let dateStr = moment(date).format("YYYY年MM月DD日 HH:mm");
    if (dateStr) {
      return dateStr;
    } else {
      return "";
    }
  },
  //毫秒转时间查看
  millisecondTOHHMMSS(millisecond) {
      if (!millisecond) {
          return "0天00时00分00秒";
      }
      var hour = parseInt(millisecond / (60 * 60 * 1000));
      var day = parseInt(hour / 24);
      var minute = parseInt((millisecond - hour * 60 * 60 * 1000) / (60 * 1000));
      var second = parseInt((millisecond - hour * 60 * 60 * 1000 - minute * 60
              * 1000)
              / 1000);
      if (second >= 60) {
          second = second % 60;
          minute += parseInt(second / 60);
      }
      if (minute >= 60) {
          minute = minute % 60;
          hour += parseInt(minute / 60);
      }
      if (hour >= 24) {
          hour = hour % 24;
          day += parseInt(hour / 24);
      }
      var sh = "";
      var sm = "";
      var ss = "";
      if (hour < 10) {
          sh = "0" + hour;
      } else {
          sh = hour;
      }
      if (minute < 10) {
          sm = "0" + minute;
      } else {
          sm = minute;
      }
      if (second < 10) {
          ss = "0" + second;
      } else {
          ss = second;
      }
      var returnStr = '';
      if (day != 0) {
          returnStr += day + "天";
      }
      if (sh != '00') {
          returnStr += sh + "时";
      }
      if (sm != '00') {
          returnStr += sm + "分";
      }
      if (ss != '00') {
          returnStr += ss + "秒";
      }
      return returnStr;
  },
  //日期字符串转时间戳
  toTime: function (dateStr) {
    let date = moment(dateStr);
    return date.valueOf();
  },
  //获取当前时间时间戳
  getTime: function () {
    return moment().valueOf();
  },
  stringToDate: function (dateStr) {
    try {
      var date = new Date(dateStr.replace(/-/g, "/"));
      if ((date + "") == "Invalid Date") {
        return null;
      }
      return date;
    } catch (e) { return null; }
  },
  diffDay(dateTime1,dateTime2){
    var date1=this.stringToDate(dateTime1);
    var date2=this.stringToDate(dateTime2);
   return moment(date1).diff(date2, 'days');
  }
}
export default date



// WEBPACK FOOTER //
// ./src/common/js/date.js